import { type InsuranceCorporateIdentity } from "../types";

export function BIGLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M391.198 344.762C335.702 344.762 308.479 309.813 308.479 254.925C308.479 202.644 339.939 167.273 392.482 166.568C419.102 166.2 445.158 177.258 445.158 177.258C445.898 186.636 443.56 193.669 436.331 199.684C436.331 199.684 415.229 191.492 397.408 193.031C370.812 195.318 355.129 214.392 355.129 254.929C355.129 294.412 369.23 316.822 388.868 316.822C394.268 316.822 399.491 315.765 401.614 314.911V244.156C401.614 244.156 414.779 240.499 423.382 240.491C431.989 240.491 445.162 244.156 445.162 244.156V334.06L444.1 334.647C432.028 341.281 415.691 344.762 391.198 344.762Z"
        fill="white"
      />
      <path
        d="M234.411 353.283L234.407 158.008C234.407 158.008 247.584 154.39 256.203 154.39C264.814 154.409 277.959 158.031 277.959 158.031V353.283C277.959 353.283 264.814 356.925 256.203 356.925C247.58 356.921 234.411 353.283 234.411 353.283Z"
        fill="white"
      />
      <path
        d="M110.796 314.888C115.339 316.008 125.011 316.815 131.249 316.815C149.759 316.815 159.826 310.048 159.826 292.051C159.826 269.919 135.251 264.468 135.251 264.468C132.529 255.508 132.302 249.356 135.251 240.479C135.251 240.479 156.471 236.677 156.471 216.307C156.471 200.322 148.514 193.027 130.481 193.027C124.846 193.027 115.613 193.431 110.796 194.496V314.888ZM173.007 251.228C188.51 257.024 205.951 271.575 205.951 293.527C205.951 328.993 176.817 344.762 132.275 344.762C107.671 344.762 82.0931 341.273 68.4543 334.659L67.2521 334.048V177.258L68.4034 176.659C80.75 170.515 106.88 166.568 130.215 166.568C177.542 166.568 200.802 186.652 200.802 213.601C200.802 234.108 186.497 246.157 173.007 251.228Z"
        fill="white"
      />
      <path
        d="M414.806 368.01C379.587 417.64 321.668 450 256.195 450C190.722 450 132.811 417.64 97.5803 368.01H157.301C183.678 391.239 218.294 405.316 256.195 405.316C294.104 405.316 328.716 391.235 355.094 368.01H414.806Z"
        fill="white"
      />
      <path
        d="M97.5881 143.261C132.811 93.6471 190.722 61.271 256.195 61.271C321.668 61.271 379.587 93.6471 414.81 143.261H355.097C328.716 120.032 294.104 105.947 256.195 105.947C218.29 105.947 183.678 120.036 157.305 143.261H97.5881Z"
        fill="white"
      />
    </svg>
  );
}

export const BIG: InsuranceCorporateIdentity = {
  id: "big",
  name: "BIG",
  logo: BIGLogo,
  backgroundColor: "#014785",
  textColor: "#FFFFFF",
  wildcard: "big direkt gesund",
  type: "statutory",
};
